'use client';

import { useSearchPageData } from '@/app/components/search/searchPageDataProvider';
import { hasAnyTripAdvisorSource } from './reviewSource';

/**
 * True when at least one hotel in the current result list carries a TripAdvisor source.
 * Drives the page-level rating-filter thresholds (evo + non-evo): any TripAdvisor hotel in the
 * list forces the TA values, otherwise the TrustYou values show. Outside the search page
 * (no `SearchPageDataProvider`) it safely resolves to false → TrustYou.
 */
export const useHasTripAdvisorHotels = (): boolean => {
  const { productsData } = useSearchPageData();
  return hasAnyTripAdvisorSource((productsData?.dealCards ?? []).map((dealCard) => dealCard.reviewSource));
};
